/**
 * Created by alvinoktavianus on 5/9/17.
 */

import { call, put, takeLatest } from 'redux-saga/effects'
import { initialize } from 'redux-form'
import _ from 'lodash'
import moment from 'moment'
import {
  SETTING_BILLING_BILLINGS,
  SETTING_BILLING_CANCEL_FEATURE_SUBSCRIPTION,
  SETTING_BILLING_FEATURE_SUBSCRIPTION_PRICE,
  SETTING_BILLING_ON_CHANGE_SUBSCRIPTION_RULES,
  SETTING_BILLING_ON_CLICK_CANCEL_FEATURE_SUBSCRIPTION_MODAL,
  SETTING_BILLING_ON_CLICK_TURN_BUTTON,
  SETTING_BILLING_PAGE_REQUEST,
  SETTING_BILLING_PAY_MOKA_SUBSCRIPTION,
  SETTING_BILLING_RULES_OUTLETS_SUBSCRIPTION_RULES
} from 'actions/setting/billing/constant'
import {
  cancelSubscription,
  getAllOutlets,
  getBillings,
  getFeatureSubscriptionPrice,
  getOutlets,
  getRules,
  getSubscriptionStatus,
  verifyBilling
} from 'api/billing'
import {
  billings,
  featureSubscriptionPrice,
  hideCancelSubscriptionModal,
  hidePaymentGatewayErrorModal,
  isClickedPayButton,
  payButtonMessage,
  rulesOutletsSubscriptionStatus,
  setBillings,
  setCancelSubsciptionModalData,
  setCountFeatureSubscription,
  setCurrentSubscriptionPlanName,
  setCurrentSubscriptionRules,
  setFeatureSubscriptionPrice,
  setIsDeletedOutlet,
  setMinMaxDate,
  setOutlets,
  setPendingPaymentMessage,
  setRules,
  setSubscriptionStatus,
  setTotalBillingPrice,
  setUnusedOutletMessage,
  showCancelSubscriptionModal,
  showPaymentGatewayErrorModal
} from 'actions/setting/billing'
import { setNotificationMessage, setNotificationType } from 'actions/billingRedirect'
import * as action from 'actions'
import * as apiProfile from 'api/profile'
import * as actNotif from 'actions/notifications'
import { showBillingNotification } from 'actions/billingNotification'
import { showSubscriptionExpiredModal } from 'actions/subscriptionExpired'
import { showPageLoadingSpinner } from 'actions/loadingSpinner'
import * as mpSettingBilling from 'mixpanel/settings/billing'
import * as is from 'is_js'

export function * getBillingsFlow () {
  yield put(action.sendingRequest(true))
  yield put(action.showProgressBar())
  yield put(showPageLoadingSpinner(true))
  try {
    const response = yield call(getBillings)
    let pendingPaymentMessage = null
    _.forEach(response.data, (invoice) => {
      if (invoice.status === 'pending') {
        if (invoice.payment_type === 'credit_card') {
          pendingPaymentMessage = `There is a pending payment for ${invoice.invoice_number}. Please wait 24 hours before making a new payment.`
        } else if (invoice.payment_type === 'bank_transfer' || invoice.payment_type === 'echannel') {
          pendingPaymentMessage = `There is a pending payment for ${invoice.invoice_number}. Please transfer full amount of the invoice within 3 days before making a new payment. Please check your email for payment instruction.`
        }
        return false
      }
    })
    if (pendingPaymentMessage !== null) {
      yield put(setPendingPaymentMessage(pendingPaymentMessage))
      yield put(isClickedPayButton(true))
    }
    yield put(setBillings(response.data))
  } catch (error) {
  } finally {
    yield put(action.hideProgressBar())
    yield put(action.sendingRequest(false))
  }
}

export function * pageRequest (request) {
  yield put(showPageLoadingSpinner(true))
  // Reset all of the reducer state
  yield put(setBillings([]))
  yield put(setOutlets([]))
  yield put(setRules({}))
  yield put(setSubscriptionStatus([]))
  yield put(setCountFeatureSubscription(0))
  yield put(setCurrentSubscriptionRules({}))
  yield put(isClickedPayButton(false))
  yield put(payButtonMessage('Pay'))
  yield put(hidePaymentGatewayErrorModal())
  yield put(setTotalBillingPrice(0))
  yield put(setPendingPaymentMessage(null))
  yield put(setUnusedOutletMessage(null))
  yield put(setCurrentSubscriptionPlanName(null))
  yield put(hidePaymentGatewayErrorModal())
  yield put(setCancelSubsciptionModalData({}))
  yield put(setFeatureSubscriptionPrice({}))
  yield put(setMinMaxDate({}))
  let {currentPlan, expired, isOwner, billingNotification} = request.payload
  let responseProfile, isTrial, outletSlot
  try {
    responseProfile = yield call(apiProfile.getProfile)
    expired = moment(responseProfile.data.business.expired_at) <= moment()
    isTrial = responseProfile.data.business.is_trial
    outletSlot = responseProfile.data.business.outlet_slot
  } catch (error) {

  }
  if (expired) {
    if (!isOwner) {
      yield put(action.logout())
      return
    } else {
      yield put(showSubscriptionExpiredModal())
    }
  }
  yield put(billings())
  yield put(rulesOutletsSubscriptionStatus(currentPlan, expired, isTrial, outletSlot))
  yield put(showBillingNotification(billingNotification))
  yield put(featureSubscriptionPrice())
  yield put(setNotificationType(null))
  yield put(setNotificationMessage(null))
}

export function * rulesOutletsSubscriptionStatusFlow (request) {
  let {currentPlan, expired, isTrial, outletSlot} = request.payload
  let outlets, minDate, maxDate
  yield put(action.sendingRequest(true))
  yield put(action.showProgressBar())
  try {
    // Get all outlets
    if (expired) {
      const responseOutlets = yield call(getAllOutlets)
      outlets = responseOutlets.data
      _.forEach(outlets, (outlet, index) => {
        outlets[index].is_deleted = false
        outlets[index].is_available = true
      })
    } else {
      const responseOutlets = yield call(getOutlets)
      outlets = responseOutlets.data
      let dateCollection = []
      _.forEach(outlets, (outlet) => {
        dateCollection.push(
          new Date(moment(outlet.end_date).format('YYYY'),
            moment(outlet.end_date).format('MM') - 1,
            moment(outlet.end_date).format('DD'))
        )
      })
      maxDate = moment(new Date(Math.max.apply(null, dateCollection))).format('DD/MM/YYYY')
      minDate = moment(new Date(Math.min.apply(null, dateCollection))).format('DD/MM/YYYY')
      const minMaxDate = {
        minDate: minDate,
        maxDate: maxDate
      }
      yield put(setMinMaxDate(minMaxDate))
      if (maxDate !== minDate) {
        _.forEach(outlets, (outlet, index) => {
          const outletEndDate = moment(outlet.end_date).format('DD/MM/YYYY')
          if (outletEndDate === maxDate) {
            outlets[index].is_available = false
            outlets[index].is_deleted = true
          } else {
            outlets[index].is_available = true
            outlets[index].is_deleted = false
          }
        })
      } else {
        _.forEach(outlets, (outlet, index) => {
          outlets[index].is_available = true
          outlets[index].is_deleted = false
        })
      }
    }
    let isDeleted = {}
    _.forEach(outlets, (outlet) => {
      isDeleted[outlet.id] = outlet.is_deleted
    })
    yield put(setIsDeletedOutlet(isDeleted))

    // After successfully fetch outlets and update the data,
    // change it to hash map instead array
    const sortedOutlet = _.orderBy(outlets, [outlet => outlet.name.toLowerCase()], ['asc'])
    yield put(setOutlets(sortedOutlet))
    let unusedOutlet = isTrial ? 0 : outletSlot - outlets.length
    if (unusedOutlet > 0) {
      yield put(setUnusedOutletMessage(`You still have slots for additional ${unusedOutlet} outlets. Please create the outlets before making a payment.`))
      yield put(isClickedPayButton(true))
    }

    // Get all rules
    let initialRule = {}
    const responseRules = yield call(getRules)
    const rules = responseRules.data
    let currentPlanName = null
    yield put(setRules(rules))
    if (rules.subscription_plans.length > 1) {
      _.forEach(rules.subscription_plans, (plan) => {
        if (plan.name === 'Moka 12 Months') {
          initialRule = plan
        }
        if (currentPlan === plan.month) {
          currentPlanName = plan.name
        }
      })
    } else {
      initialRule = rules.subscription_plans[0]
      currentPlanName = rules.subscription_plans[0].name
    }
    currentPlanName = expired ? 'Expired' : !expired && isTrial ? 'Trial' : currentPlanName
    yield put(setCurrentSubscriptionPlanName(currentPlanName))
    yield put(setCurrentSubscriptionRules(initialRule))

    // Create redux-form initial value
    let initialValue = {
      subscriptionRules: 'Moka 12 Months'
    }

    // Initialize redux-form value
    yield put(initialize('BillingReceipt', initialValue))

    // Get all rules
    const response = yield call(getSubscriptionStatus)
    let featureSubscription = response.data
    let featureCount = 0
    _.forEach(featureSubscription, (feature) => {
      if (feature.is_active && feature.is_subscribing) {
        featureCount++
        feature.isHaveFeature = true
        feature.isFeatureNeedToBePaid = true
        feature.isFeatureActiveUntil = false // please remove is this variable is not using anymore
        feature.featureActiveUntilDate = null // please remove is this variable is not using anymore
      } else if (feature.is_active && !feature.is_subscribing) {
        featureCount++
        feature.isHaveFeature = false
        feature.featureActiveUntilDate = moment(feature.expiration_date).format('DD/MM/YYYY')
        feature.isFeatureNeedToBePaid = minDate !== maxDate ? (!(minDate >= feature.featureActiveUntilDate && maxDate >= feature.featureActiveUntilDate)) : false
        feature.isFeatureActiveUntil = true // please remove is this variable is not using anymore
      }
    })
    yield put(setCountFeatureSubscription(featureCount))
    yield put(setSubscriptionStatus(featureSubscription))
  } catch (error) {

  } finally {
    yield put(action.hideProgressBar())
    yield put(action.sendingRequest(false))
    yield put(showPageLoadingSpinner(false))
  }
}

export function * featureSubscriptionPriceFlow () {
  yield put(action.sendingRequest(true))
  yield put(action.showProgressBar())
  try {
    const response = yield call(getFeatureSubscriptionPrice)
    yield put(setFeatureSubscriptionPrice(response.data))
  } catch (error) {

  } finally {
    yield put(action.hideProgressBar())
    yield put(action.sendingRequest(false))
  }
}

export function * onChangeSubscriptionRules (newSubscriptionRules) {
  const {payload: {subscriptionRules}} = newSubscriptionRules
  yield put(setCurrentSubscriptionRules(subscriptionRules))
}

export function * payMokaSubscriptionFlow (request) {
  yield put(action.showProgressBar())
  yield put(isClickedPayButton(true))
  const {totalPrice, subscriptionPlan, purchasedOutlets, activatedFeatures} = request.payload
  let response = {}

  let billingData = {
    type: 'SubscriptionBilling',
    total_amount: totalPrice,
    subscription_plan: subscriptionPlan.month,
    feature_ids: activatedFeatures,
    purchased_outlets: purchasedOutlets
  }

  switch (billingData.subscription_plan) {
    case 1:
      billingData.subscription_name = 'Monthly'
      break
    case 12:
      billingData.subscription_name = '12 Months'
      break
    default:
      billingData.subscription_name = 'Total Payment'
  }

  mpSettingBilling.settingBillingPay({billingData})

  try {
    response = yield call(verifyBilling, billingData)
  } catch (error) {
    yield put(isClickedPayButton(false))
    if (!error.data || error.data === ' ' || error.status >= 500) {
      yield put(showPaymentGatewayErrorModal())
    } else {
      yield put(actNotif.error(error.data.message))
    }
  } finally {
    yield put(action.hideProgressBar())
    yield put(action.sendingRequest(false))
    if (response.data) {
      yield put(payButtonMessage('Redirecting to Veritrans'))
      if (is.safari()) {
        yield put(isClickedPayButton(false))
        yield put(payButtonMessage('Pay'))
      }
      window.location.href = response.data.data.redirect_url
    }
  }
}

export function * onClickCancelSubscriptionModalFlow (request) {
  yield put(showCancelSubscriptionModal())
  yield put(setCancelSubsciptionModalData(request.payload.featureSubscriptionModalData))
}

export function * cancelFeatureSubscriptionFlow (request) {
  const {featureSubscriptionStatus} = request.payload
  const {outletMinMaxDate: {minDate, maxDate}} = request.payload
  try {
    const response = yield call(cancelSubscription, request.payload.featureName)
    let newFeatureStatus = response.data[0]
    _.forEach(featureSubscriptionStatus, (feature, index) => {
      if (feature.id === newFeatureStatus.id) {
        featureSubscriptionStatus[index] = newFeatureStatus
        featureSubscriptionStatus[index].isHaveFeature = false
        featureSubscriptionStatus[index].featureActiveUntilDate = moment(feature.expiration_date).format('DD/MM/YYYY')
        featureSubscriptionStatus[index].isFeatureNeedToBePaid = minDate !== maxDate ? (!(minDate >= feature.featureActiveUntilDate && maxDate >= feature.featureActiveUntilDate)) : false
        featureSubscriptionStatus[index].isFeatureActiveUntil = true
      }
    })
    yield put(setSubscriptionStatus([]))
    yield put(setSubscriptionStatus(featureSubscriptionStatus))
  } catch (error) {

  } finally {
    yield put(hideCancelSubscriptionModal())
  }
}

export function * onClickTurnButtonFlow (request) {
  const {id, prevIsDeleted} = request.payload
  const newDeleted = {...prevIsDeleted}
  newDeleted[id] = !prevIsDeleted[id]
  yield put(setIsDeletedOutlet(newDeleted))
}

export default function * settingBillingSaga () {
  yield takeLatest(SETTING_BILLING_PAGE_REQUEST, pageRequest)
  yield takeLatest(SETTING_BILLING_RULES_OUTLETS_SUBSCRIPTION_RULES, rulesOutletsSubscriptionStatusFlow)
  yield takeLatest(SETTING_BILLING_BILLINGS, getBillingsFlow)
  yield takeLatest(SETTING_BILLING_ON_CHANGE_SUBSCRIPTION_RULES, onChangeSubscriptionRules)
  yield takeLatest(SETTING_BILLING_PAY_MOKA_SUBSCRIPTION, payMokaSubscriptionFlow)
  yield takeLatest(SETTING_BILLING_ON_CLICK_CANCEL_FEATURE_SUBSCRIPTION_MODAL, onClickCancelSubscriptionModalFlow)
  yield takeLatest(SETTING_BILLING_FEATURE_SUBSCRIPTION_PRICE, featureSubscriptionPriceFlow)
  yield takeLatest(SETTING_BILLING_CANCEL_FEATURE_SUBSCRIPTION, cancelFeatureSubscriptionFlow)
  yield takeLatest(SETTING_BILLING_ON_CLICK_TURN_BUTTON, onClickTurnButtonFlow)
}



// WEBPACK FOOTER //
// ./app/sagas/setting/billing.js